import React from 'react';
import { createApiConfigQueryHashMap, getQueryHashKey } from '../../apis-infra';
import { useIsFetching } from 'react-query';
export const useIsApiFetching = function (apiConfig) {
  for (var _len = arguments.length, methods = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    methods[_key - 1] = arguments[_key];
  }
  const queryKeysMap = React.useMemo(() => createApiConfigQueryHashMap(apiConfig, ...methods), [apiConfig, methods]);
  return useIsFetching({
    predicate: query => {
      const hashKey = getQueryHashKey(query.queryKey);
      return !!queryKeysMap[hashKey];
    }
  });
};
export const useIsApiFetchingByTags = function () {
  for (var _len2 = arguments.length, tags = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    tags[_key2] = arguments[_key2];
  }
  return useIsFetching({
    predicate: query => {
      if (!(tags != null && tags.length)) {
        return false;
      }
      const queryTags = query.queryKey.filter(key => {
        var _key$;
        return typeof key === 'string' && ((_key$ = key[0]) == null ? void 0 : _key$[0]) === '#';
      });
      return queryTags.some(tag => tags.includes(tag));
    }
  });
};
//# sourceMappingURL=useIsApiFetching.js.map